export enum AuthRole {
  Admin = 'Admin',
  Dealer = 'Dealer',
  Investor = 'Investor',
  User = 'User',
}

export const TOKEN_KEY = 'authToken';

export enum ReadScope {
  None,
  // e.g. dealers see all transactions
  All,
  // e.g. investors see their own transactions
  Self,
}
